import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl";

import Images from "../theme/Images";
import * as routes from "../constants/routes";

class DetailerWhyChooseUs extends Component {
  static propTypes = {
    intl: PropTypes.shape({}).isRequired
  };

  translateMessage = messageID => {
    const { intl } = this.props;
    return intl.formatMessage({ id: messageID });
  };

  render() {
    const componentName = "DetailerWhyChooseUs";
    let wcuSectionID = 0;
    const wcuSectionsJSON = [
      {
        id: wcuSectionID++,
        image: Images.icon_work,
        imageAltID: "WorkForYourselfTitle",
        titleID: "WorkForYourselfTitle",
        contentID: "WorkForYourselfContent"
      },
      {
        id: wcuSectionID++,
        image: Images.icon_customers,
        imageAltID: "KeepYourCustomersTitle",
        titleID: "KeepYourCustomersTitle",
        contentID: "KeepYourCustomersContent"
      },
      {
        id: wcuSectionID++,
        image: Images.icon_workload,
        imageAltID: "ConsistentWorkloadTitle",
        titleID: "ConsistentWorkloadTitle",
        contentID: "ConsistentWorkloadContent"
      },
      {
        id: wcuSectionID++,
        image: Images.icon_money,
        imageAltID: "TransparentPricingTitle",
        titleID: "TransparentPricingTitle",
        contentID: "TransparentPricingContent",
        contentParams: { PRICING_LINK: routes.DETAILER_PACKAGES }
      },
      {
        id: wcuSectionID++,
        image: Images.icon_bank,
        imageAltID: "FastTransferTitle",
        titleID: "FastTransferTitle",
        contentID: "FastTransferContent",
        contentParams: { STRIPE_LINK: routes.STRIPE_WEBSITE }
      },
      {
        id: wcuSectionID++,
        image: Images.icon_realtime,
        imageAltID: "RealtimeTitle",
        titleID: "RealtimeTitle",
        contentID: "RealtimeContent"
      }
    ];

    return (
      <div>
        <h1 style={{ clear: "both" }}>
          <FormattedMessage id={`${componentName}.Title`} />
        </h1>
        {wcuSectionsJSON.map(section => {
          const {
            id,
            image,
            imageAltID,
            titleID,
            contentID,
            contentParams
          } = section;
          return (
            <section key={id}>
              <img
                src={image}
                alt={this.translateMessage(`${componentName}.${imageAltID}`)}
              />
              <div>
                <h2>
                  <FormattedMessage id={`${componentName}.${titleID}`} />
                </h2>
                <FormattedHTMLMessage
                  id={`${componentName}.${contentID}`}
                  values={contentParams}
                />
              </div>
            </section>
          );
        })}
      </div>
    );
  }
}

export default injectIntl(DetailerWhyChooseUs);



// WEBPACK FOOTER //
// ./src/components/DetailerWhyChooseUs.js